import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.png";

export const mimecast = defineConnector({
  identifier: "mimecast",
  name: "Mimecast",
  tagLine: "Email security and management",
  logo,
  protocol: "http",
  tags: ["security", "communication"],
  defaultUrlPattern: () => "https://api\\.services\\.mimecast\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create an API 2.0 application in Mimecast",
      items: [
        {
          kind: "markdown",
          content: `1. In the Mimecast platform, click **Integrations › Mimecast API 2.0**
2. Click **Generate Token**
3. Accept the legal terms
4. Fill in your application details (name, category, role)
5. Fill in your notification settings
6. Click **Add and Generate Keys**
7. Copy the client ID and client secret`,
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: () => "https://api.services.mimecast.com/oauth/token",
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_post",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://api.services.mimecast.com/api/account/get-account",
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ data: [] }),
    }),
  },
});
